module.exports = __webpack_public_path__ + "static/media/exampleImg.e8e588f7.jpg";